import React from 'react';
import { C } from '../../constants/design-tokens';

export const labelStyle: React.CSSProperties = { fontSize: 12, color: C.textSecondary, minWidth: 90 };
export const rowStyle: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 10, marginTop: 12 };
export const valueStyle: React.CSSProperties = { fontSize: 12, color: C.textPrimary, minWidth: 44, textAlign: 'right' };

export const segmentBtn = (active: boolean): React.CSSProperties => ({
  flex: 1,
  padding: '6px 8px',
  fontSize: 12,
  border: `1px solid ${active ? C.textPrimary : C.border}`,
  background: active ? C.textPrimary : 'transparent',
  color: active ? '#fff' : C.textSecondary,
  borderRadius: 6,
  cursor: 'pointer'
});

export const pillToggleBtn = (active: boolean): React.CSSProperties => ({
  padding: '4px 8px',
  fontSize: 11,
  border: `1px solid ${active ? C.textPrimary : C.border}`,
  background: active ? C.textPrimary : 'transparent',
  color: active ? '#fff' : C.textSecondary,
  borderRadius: 6,
  cursor: 'pointer'
});
